import { COMPONENT_ITEM_TYPES } from '../types/ComponentItemTypes';
export function isComponentItemType(itemType) {
    return COMPONENT_ITEM_TYPES.includes(itemType);
}
